'use strict';
const angular = require('angular');
import ServicesController from './services.controller';
import routes from './services.routes';

export default angular.module('nomasvelloDashboardApp.services', [])
    .config(routes)
    .controller('ServicesController', ServicesController)
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/services/index.ts